import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordBackLocation } from "../util/backNavigation";

/**
 * Records every visited route (except those excluded in backNavigation.ts)
 * so detail pages' Back buttons can return to the page the user was on
 * before opening them. Mount once in the layout that wraps all routes
 * (MobileLayout).
 */
export const useRecordBackLocation = (): void => {
  const location = useLocation();

  useEffect(() => {
    recordBackLocation(location.pathname, location.search);
  }, [location.pathname, location.search]);
};
